import React from 'react';

import ROUTES from '../../routes';
import Page2ColumnLayout from '../utility/page2-column-layout/Page2ColumnLayout';
import { useTranslation } from '../../hooks/useTranslation';
import AccountLeftNavBlock from '../utility/account-left-nav-block';

type Props = {
  children: any;
  dense?: boolean | undefined;
};

const ProfileLayout = ({ children, dense = true }: Props) => {
  const { t } = useTranslation();

  return (
    <Page2ColumnLayout dense={dense} leftColumn={<AccountLeftNavBlock />}>
      {children}
    </Page2ColumnLayout>
  );
};

export default ProfileLayout;
